import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-07",
  "use": "icon-attr-shape-07-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-07\"><path d=\"M26.135 7.003C24.9 5.677 23.26 5 21.623 5c-1.638 0-3.252.677-4.512 2.003L16.052 8.14l-1.058-1.137C13.759 5.677 12.12 5 10.482 5c-2.596 0-5.167 1.678-6.2 5.008-.681 2.246-.101 4.737 1.461 6.415l9.528 10.232c.429.46 1.084.46 1.512 0l9.301-9.988c2.546-2.653 2.546-7.011.05-9.664z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol